var React = require('react');

function LliconRemoveDark (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(31.678 -60.67) rotate(45)"},[React.createElement("line",{"fill":"none","stroke":"#2f4758","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5px","x2":"16","transform":"translate(28.5 65.3)","key":0}),React.createElement("line",{"fill":"none","stroke":"#2f4758","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5px","x2":"16","transform":"translate(36.5 57.3) rotate(90)","key":1})]));
}

LliconRemoveDark.defaultProps = {"width":"22.627","height":"22.627","viewBox":"0 0 22.627 22.627"};

module.exports = LliconRemoveDark;

LliconRemoveDark.default = LliconRemoveDark;
